<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 col-w-full col-lg-10 col-xl-8">
        <div class="card">
          <WhiteLabel class="d-flex">
            <h3 class="font-weight-light pull-left ml-3">Pessoa Física</h3>
            <router-link
              :to="{ name: 'customer' }"
              class="ml-auto mt-1 pull-right mr-4"
            >
              <i class="icon-arrow-left-circle"></i> Voltar
            </router-link>
          </WhiteLabel>
          <hr />
          <form action="#" @submit.prevent="save()" autocomplete="off">
            <div class="card-content mb-5">
              <div class="form-row">
                <div class="col-sm-12">
                  <WhiteLabel>
                    <h4 class="font-weight-light blue">Dados do Cliente</h4>
                  </WhiteLabel>
                </div>
                <div class="form-group col-12 col-w-full col-lg-7 mb-4">
                  <label for="inputNome">Nome</label>
                  <p>{{ customer.fullName }}</p>
                </div>
                <div class="form-group col-12 col-w-full col-lg-5 mb-4">
                  <label for="inputCPF">CPF</label>
                  <p>{{ customer.taxDocument }}</p>
                </div>
                <div class="form-group col-6 col-lg-4 col-xl-4 mb-4">
                  <label>Gênero</label>
                  <p>
                    {{ customer.gender === "F" ? "Feminino" : "Masculino" }}
                  </p>
                </div>
                <div class="form-group col-6 col-lg-3 col-xl-3 mb-4">
                  <label for="inputBirthDate">Data Nascimento</label>
                  <p>{{ customer.birthDate | moment("DD/MM/YYYY") }}</p>
                </div>
              </div>
            </div>
            <div class="card-content mb-5">
              <contact-information :customer="customer" />
            </div>
            <div class="card-content mb-5">
              <address-customer :customer="customer" />
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import paggcerto from 'paggcerto-lightbox/src/js';
import AddressCustomer from './AddressCustomer';
import ContactInformation from './ContactInformation';
import { Customer } from '@/models/Customer';
import BusinessApi from '@/services/BusinessApi';
import { PermissionList } from '@/models/Permission';
import WhiteLabel from '@/components/shared/WhiteLabel';

export default {
  name: 'AppPhysicalCustomer',
  data() {
    return {
      permissionList: new PermissionList(),
      customer: new Customer(),
    };
  },
  async mounted() {
    this.$bus.$emit('spinner-run');
    await this.findCustomer();
    if (this.whoAmI.user.role !== null) {
      await this.getScopes();
    }
    this.$bus.$emit('spinner-stop');
  },
  components: {
    AddressCustomer,
    ContactInformation,
    WhiteLabel,
  },
  computed: {
    ...mapGetters({
      whoAmI: 'account/whoAmI',
      token: 'account/token',
    }),
    paymentsPermissionIndex() {
      return this.permissionList.permissions.findIndex(
        (x) => x.name === 'payments'
      );
    },
    isAccountHolder() {
      if (!this.whoAmI) return '';
      return this.whoAmI.accessedByHolder;
    },
    salesPermission() {
      if (
        (this.permissionList.permissions[this.paymentsPermissionIndex].grant ===
          'create' ||
          this.isAccountHolder) &&
        this.isAccountActive
      ) {
        return true;
      } else {
        return false;
      }
    },
    isAccountActive() {
      if (!this.whoAmI) return '';
      return this.whoAmI.account.active;
    },
  },
  methods: {
    ...mapActions({
      askWhoAmI: 'account/askWhoAmI',
    }),
    async findCustomer() {
      const api = new BusinessApi();
      var customer = await api.customers.find(this.$route.params.customerId);
      this.customer = customer;
    },
    async getScopes() {
      this.permissionList.fromScopes(this.whoAmI.user.role.scopes);
    },
    payWithBankSlip() {
      paggcerto.lightbox({
        environment: process.env.VUE_APP_LIGHTBOX,
        token: this.token,
        payment: {
          amount: null,
          replicateAmount: true,
          bankSlipEnabled: true,
          creditEnabled: false,
          debitEnabled: false,
          payers: [
            {
              sellingKey: null,
              fullName: this.customer.fullName,
              taxDocument: this.customer.taxDocument,
            },
          ],
        },
      });
    },
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    customerEdit: {
      type: Object,
      default: null,
    },
  },
};
</script>
